export interface iMessage {
    error: string;
    message: string;
};

const messages: iMessage[] = [
    // Errores de Missing
    { error: 'campoRequerido', message: 'Este campo es obligatorio' },
    // Errores contraseña
    { error: 'passwordMismatchError', message: 'Las contraseñas no coinciden' },
    { error: 'passwordMinLengthError', message: 'La contraseña debe tener al menos 8 caracteres' },
    { error: 'weakPasswordError', message: 'Tu contraseña es vulnerable. Incluye mayúsculas y números.' },
    { error: 'mediumPasswordError', message: 'La contraseña podría ser más segura. Incluye caracteres especiales y mayúsculas' },
    { error: 'wrong_password', message: 'La contraseña proporcionada es incorrecta. Por favor, verifica tu contraseña e intenta nuevamente.' },
    // Errores inicio sesión
    { error: 'invalid_credential', message: 'El correo o contraseña proporcionados son incorrectos.' },
    // Errores Registro
    { error: 'email_use', message: 'El correo electrónico ya está en uso por otra cuenta.' },
    { error: 'invalid_email', message: 'El correo electrónico proporcionado no es válido.' },
    // Errores recuperación contraseña
    { error: 'userNotFound', message: 'No existe ninguna cuenta asociada con este correo electrónico. Verifica que la dirección de correo electrónico sea la registrada.' },
    // Errores validación
    { error: 'invalidEmail', message: 'Correo electrónico inválido. Verifica la dirección de correo electrónico proporcionada.' },
    { error: 'successMessage', message: 'Revisa tu correo para restablecer la contraseña.' },
    // Otros Errores 
    { error: 'missingAndroidPkgName', message: 'Falta el nombre del paquete de Android en la configuración de Firebase. Contacta al administrador.' },
    { error: 'missingContinueUri', message: 'Falta el URI de continuación en la configuración de Firebase. Contacta al administrador.' },
    { error: 'tooManyRequests', message: 'Demasiados intentos. Inténtalo de nuevo más tarde.' },
    { error: 'network_request_failed', message: 'Hay problema con la red. Por favor, verifica tu conexión a Internet e intenta nuevamente.' },
    { error: 'unknownError', message: 'Lo sentimos, se ha producido un error al procesar tu solicitud. Por favor, inténtalo de nuevo más tarde.' }, 
    { error: 'unavailable', message: 'Lo sentimos, la aplicación no puede conectarse al backend de Cloud Firestore. Por favor, inténtalo de nuevo más tarde.' },    
    
];


export default messages;